import React from 'react';
import { MarkerSide } from '../../state/types';

interface ReadingMarkerProps {
  enabled: boolean;
  centerPercent: number;
  heightPercent: number;
  color: string;
  width: number;
  offset: number;
  opacity: number;
  side: MarkerSide;
  isRtl: boolean;
}

export const ReadingMarker: React.FC<ReadingMarkerProps> = ({
  enabled,
  centerPercent,
  heightPercent,
  color,
  width,
  offset,
  opacity,
  side,
  isRtl,
}) => {
  if (!enabled || opacity <= 0 || width <= 0) return null;

  const topPercent = Math.max(0, centerPercent - heightPercent / 2);

  // Determine effective side
  let effectiveSide: 'left' | 'right' = 'right';
  if (side === 'auto') {
    effectiveSide = isRtl ? 'right' : 'left';
  } else {
    effectiveSide = side;
  }

  const style: React.CSSProperties = {
    top: `${topPercent}%`,
    height: `${heightPercent}%`,
    width: `${width}px`,
    backgroundColor: color,
    opacity,
    position: 'absolute',
    ...(effectiveSide === 'right' ? { right: `${offset}px` } : { left: `${offset}px` }),
  };

  return (
    <div
      className="pointer-events-none z-30 rounded-full shadow-sm"
      style={style}
      aria-hidden="true"
    />
  );
};
